/* Discounts customer tags */

document.addEventListener('DOMContentLoaded', function () {
    const couponMapping = [
      {
        eligible: window.customerEligibleForMiembroClubRes,
        coupon: 'miembroclubres',
      }
    ];
  
    const checkoutButton = document.querySelector('button.checkout-button.button.full');
  
    if (checkoutButton) {
      for (const { eligible, coupon } of couponMapping) {
        if (eligible) {
          //console.log(`Cliente elegible para el cupón: ${coupon}`);
  
          const newButton = document.createElement('a');
          newButton.href = `/checkout?discount=${coupon}`;
          newButton.textContent = 'Finalizar la compra';
          newButton.className = checkoutButton.className;
          newButton.style.cssText = checkoutButton.style.cssText;
          newButton.role = 'button';
          newButton.dataset.testId = `checkout-${coupon}`;

          checkoutButton.replaceWith(newButton);
          break;
        }
      }
    } else {
      //console.error('No se encontró el botón de checkout.');
    }
  });